export default __webpack_public_path__ + "static/media/metro.598ec9c8.svg";